export default __webpack_public_path__ + "assets/colombia-flag.png";